import type { LoyaltyCardCTAs, LoyaltyLevel } from './api';
import type { ILoyaltyLevel } from './api/loyalty-sse';

export const CardStatus = {
  UNREGISTERED: 'unregistered',
  LOCKED: 'locked',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
} as const;

/** First level in the loyalty program (no retention requirements) */
export const FIRST_LEVEL_INDEX = 1;

/** Index of the one-time bonus perk in the perks array */
export const ONE_TIME_BONUS_PERK_INDEX = 0;

/** Index offset to convert 0-based array index to 1-based card index */
export const CARD_INDEX_OFFSET = 1;

/** Home page path for redirects */
export const HOME_PATH = '/';

export type CardStatusType = (typeof CardStatus)[keyof typeof CardStatus];

export interface ICardProps extends LoyaltyCardCTAs {
  level: LoyaltyLevel;
  sseLevel: ILoyaltyLevel | null;
  /** 1-based index of the card in the levels array */
  index: number;
  isLast: boolean;
}
